export default function CheckIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      strokeLinejoin='round'
      stroke='currentColor'
      strokeLinecap='round'
      viewBox='0 0 24 24'
      aria-hidden='true'
      strokeWidth='2'
      fill='none'
      height='24'
      width='24'
    >
      <path d='M20 6 9 17l-5-5' />
    </svg>
  )
}
